import { CodeHighlight } from '@mantine/code-highlight';
import { Button } from '@mantine/core';
import { IconBrandGithub, IconKeyFilled } from '@tabler/icons-react';
import dedent from 'dedent';
import { useManageApiKeyPage } from '~/hooks/auth/use-manage-api-key-page';

export default function GithubCIInstruction({ testSuiteId }: { testSuiteId?: string }) {
  const { manageApiKeyPageUrl, showModalIfNotAuthorized } = useManageApiKeyPage();

  const gitHubActionYaml = dedent`
  name: Stably Test Runner Example

  on:
    pull_request:

  # Make sure to set these permissions if using the \`github-comment\` option
  permissions:
    pull-requests: write
    contents: write

  jobs:
    stably-test-action:
      name: Stably Test Runner
      runs-on: ubuntu-latest
  
      steps:
        - name: Stably Runner Action
          uses: stablyai/stably-runner-action@v4
          with:
            test-suite-id: ${testSuiteId}
            api-key: \${{ secrets.STABLY_API_KEY }}
  `;

  return (
    <>
      GitHub action usage example:
      <CodeHighlight
        code={gitHubActionYaml}
        language="yaml"
      />
      <div className="mt-4 flex flex-row gap-2">
        <Button
          component="a"
          target="_blank"
          rel="noopener noreferrer"
          leftSection={<IconKeyFilled size={16} />}
          onClick={showModalIfNotAuthorized}
          href={manageApiKeyPageUrl}
        >
          Get API Key
        </Button>
        <Button
          variant="outline"
          component="a"
          leftSection={<IconBrandGithub size={16} />}
          target="_blank"
          rel="noopener noreferrer"
          href="https://github.com/marketplace/actions/stably-runner#classic-v1"
        >
          View on Marketplace
        </Button>
      </div>
    </>
  );
}
